import  loaderReducer from './reducers';

export { default as loaderOperations } from './operations';
export { default as loaderTypes } from './types';

export default loaderReducer;